export default function MarqueeStrip({ items = [], speed = "60s", repeat = 6 }) {
  const baseLoop = Array.from({ length: repeat }, () => items).flat();
  const doubled = [...baseLoop, ...baseLoop];

  return (
    <div className="motif-marquee">
      <div
        className="motif-marquee-track"
        style={{
          animationDuration: speed,
        }}
      >
        {doubled.map((item, idx) => (
          <span key={idx}>{item}</span>
        ))}
      </div>
    </div>
  );
}
